import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';

export default store => ({
  path : '/admin/infos',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Counter = require('./containers/InfosContainer').default;
      let reducer;
      const sagas = require('sagas/sagas').default;

      const reducerArray = ['textInfos'];
      reducerArray.forEach((item) => {
        reducer = require(`reducers/${item}`).default; // eslint-disable-line
        injectReducer(store, { key: item, reducer });
      });

      injectSagas(store, { key: 'sagas', sagas });

      cb(null, Counter);
    }, 'infos');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Infos/index.js